import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        function onScroll({ direction, scroll }) {
            if (scroll < 40) {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.remove('is-scrolling-down');
            } else if (direction === -1) {
                document.querySelector('html').classList.add('is-scrolling-up');
                document.querySelector('html').classList.remove('is-scrolling-down');
            } else if (direction === 1) {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.add('is-scrolling-down');
            } else {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.add('is-scrolling-down');
            }
            if (scroll > 40) {
                document.querySelector('html').classList.add('has-header-fixed');
            } else {
                document.querySelector('html').classList.remove('has-header-fixed');
            }
        }

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

        window.addEventListener('hideHeader', (e) => {
            const { target, way, from } = e.detail;
            if (way === 'enter') {
                document.querySelector('html').classList.add('hide-header');
            } else if (way === 'leave') {
                document.querySelector('html').classList.remove('hide-header');
            } else {
                document.querySelector('html').classList.remove('hide-header');
            }
        });

        window.addEventListener('playLottie', (e) => {
            const { way } = e.detail;
            if (way === 'enter') {
                document.querySelector('.js-section-logo-player').play();
            } 
        });

        window.addEventListener('hideAlert', (e) => {
            const { target, way, from } = e.detail;
            if (way === 'enter') {
                document.querySelector('html').classList.add('hide-alert');
            } else if (way === 'leave') {
                document.querySelector('html').classList.remove('hide-alert');
            } else {
                document.querySelector('html').classList.remove('hide-alert');
            }
        });

        this.tl = gsap.timeline();
        this.tl.fromTo("#anim-logo-1", {autoAlpha: 1, filter:"blur(0px)"}, {autoAlpha: 0, filter:"blur(5px)", duration: 1.5}, "+=1");
        this.tl.fromTo("#anim-logo-2", {autoAlpha: 0, filter:"blur(5px)", scale: 0.9}, {autoAlpha: 1, filter:"blur(0px)", scale: 1, duration: 3}, "-=0.5");

        window.addEventListener('logoTransition', (e) => {
            const { target, way, from } = e.detail;

            if (way === 'enter') {
                this.tl.play(0);
            } else if (way === 'leave') {
                this.tl.pause();
            }
        });
    }

    scrollToEl(attr) {
        window.locomotiveScroll.scrollTo(attr.element, attr.options);
    }

    destroy() {
        super.destroy();
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        document.querySelector('html').classList.remove(
            'is-scrolling-up',
            'is-scrolling-down',
            'has-header-fixed',
            'hide-header',
            'hide-alert'
        );
    }
}